import { render, staticRenderFns } from "./AppProfileMenu.vue?vue&type=template&id=570cdc8f&scoped=true&"
import script from "./AppProfileMenu.vue?vue&type=script&lang=js&"
export * from "./AppProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppProfileMenu.vue?vue&type=style&index=0&id=570cdc8f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570cdc8f",
  null
  
)

export default component.exports